import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Icon from '../Icon';

/**
 * Export the button icon component.
 *
 * @param buttonText
 * @returns {XML}
 * @constructor
 */
const ButtonIcon = ({ icon, iconColor, width, height, className }) => {
    const StyledIcon = styled.span`
        display: inline-flex;
        padding: 0 0.31em 0 0;
        position: relative;
        bottom: -0.125em;
    `;

    const iconName = `icon-${icon}`;

    return (
        <StyledIcon >
            <Icon
                name={iconName}
                className={className}
                width={width}
                height={height}
                iconColor={iconColor}
            />
        </StyledIcon >
    );
};

ButtonIcon.defaultProps = ({
    iconColor: null,
    width: '1.5em',
    height: '1.5em',
    className: null,
});

ButtonIcon.propTypes = ({
    icon: PropTypes.string.isRequired,
    iconColor: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    className: PropTypes.string,
});

export default ButtonIcon;



// WEBPACK FOOTER //
// ./src/components/buttons/ButtonIcon.js